import { lazy } from 'react';

import type { RouterType } from 'commons/modules/routers/routes';
import { MENU_KEYS, SCREENS_KEYS } from 'constants/constants';

import { createRouteItem } from 'utils/navigation';

import CreateClientRoutes from './CreateClient/routes';
import CreateMoralPersonRoutes from './CreateMoralPerson/routes';
import ClientInfoRoutes from './Positions/routes';

const ClientsManagementView = lazy(
  () => import('views/Clients/ClientsManagement'),
);
const CreateClientView = lazy(() => import('./CreateClient'));
const CreateMoralPersonView = lazy(() => import('./CreateMoralPerson'));
const CreateFideicomisoPersonView = lazy(
  () => import('./CreateFideicomisoPerson'),
);
const ClientInfoView = lazy(() => import('./Positions'));
const CoOwnersOnboardingView = lazy(
  () => import('views/NewClient/Onboarding/CoOwners'),
);
const CreateMassUploadPersonView = lazy(
  () => import('./CreateMassUploadPerson'),
);
const NewClientView = lazy(() => import('views/NewClient'));

const routers: RouterType[] = [
  {
    path: '/clientes',
    component: ClientsManagementView,
    exact: true,
    breadcrumbs: {
      title: 'Administración de clientes',
      routes: [createRouteItem('Home', '/')],
    },
  },

  {
    exact: true,
    path: '/clientes/fisica/:clientId/cotitular/nuevo',
    component: CoOwnersOnboardingView,
    breadcrumbs: {
      title: 'Cotitular',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Administración de clientes', '/clientes'),
      ],
    },
  },
  {
    exact: true,
    path: '/clientes/fisica/:clientId/cotitular/:coOwnerId',
    component: CoOwnersOnboardingView,
    breadcrumbs: {
      title: 'Cotitular',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Administración de clientes', '/clientes'),
      ],
    },
  },
  {
    path: '/clientes/nuevo',
    component: CreateClientView,
    routes: CreateClientRoutes,
    breadcrumbs: {
      title: 'Nuevo Cliente',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Administración de clientes', '/clientes'),
      ],
    },
  },
  {
    path: '/clientes/fisica/:clientId',
    component: CreateClientView,
    routes: CreateClientRoutes,
    breadcrumbs: {
      title: 'Cliente',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Administración de clientes', '/clientes'),
      ],
    },
  },
  {
    path: '/clientes/moral/nuevo',
    component: CreateMoralPersonView,
    routes: CreateMoralPersonRoutes,
  },
  {
    path: '/clientes/moral/:clientId',
    component: CreateMoralPersonView,
    routes: CreateMoralPersonRoutes,
  },
  {
    path: '/clientes/fideicomiso/nuevo',
    component: CreateFideicomisoPersonView,
    routes: CreateFideicomisoPersonView,
  },
  {
    path: '/clientes/fideicomiso/:clientId',
    component: CreateFideicomisoPersonView,
    routes: CreateFideicomisoPersonView,
  },
  {
    path: '/clientes/carga-masiva',
    component: CreateMassUploadPersonView,
    routes: CreateMassUploadPersonView,
  },
  {
    exact: true,
    path: '/clientes/onboarding',
    component: NewClientView,
    menuKey: MENU_KEYS.clients,
    screenKey: SCREENS_KEYS.newClient,
  },
  {
    path: '/clientes/:clientid',
    component: ClientInfoView,
    routes: ClientInfoRoutes,
    breadcrumbs: {
      title: 'Selecciona tu portafolio',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Clientes', '/clientes'),
      ],
    },
  },
];

export default routers;
